module.exports = __webpack_public_path__ + "static/media/instructivoaf3.7df0f439.png";